
import { LANGUAGES_IN_PICKER } from '@shared/config/lang.js'

export default {
    name: 'CurrentLanguageMenuItem',

    props: {
        hasArrow: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            activeLanguage: '',
        }
    },

    computed: {
        langs() {
            return LANGUAGES_IN_PICKER || []
        },
        flag() {
            if (this.activeLanguage === 'en') return 'gb'
            if (this.activeLanguage === 'da') return 'dk'
            return this.activeLanguage
        },
    },

    beforeMount() {
        const activeLocale = this.langs.find(
            (lang) => lang.locale === this.$locale
        )
        this.activeLanguage = activeLocale.locale
    },
}
